import React from 'react'
import styles from './PaymentLines.module.scss'

function PaymentLines({ PaymentData }) {
	return (
		<div>
			<ul className={styles.paymentLines}>
				{PaymentData.map((item, index) => (
					<li key={index}>
						{item.data}{' '}
						{item.itemData && <span>{item.itemData}</span>}
					</li>
				))}
			</ul>
		</div>
	)
}

export default PaymentLines
